import type { FetchTrackedOneGraphOperation } from './ApolloNativeModule';
import type { FragmentRegistryAPI } from '@apollo/client/cache';

import { createOneGraphApolloClient } from './createOneGraphApolloClient';

import {
    type ApolloCache,
    type ApolloLink,
    ApolloProvider,
    type DefaultOptions,
    type NormalizedCacheObject,
    type TypePolicies,
} from '@apollo/client';
import { useMemo } from 'react';

export interface PlatformOptions {
    web?: {
        graphqlUrl?: string;
        graphqlApiKey?: string;
    };
}

export interface Props {
    children?: React.ReactNode;
    fetch: FetchTrackedOneGraphOperation;
    rootTrackingKey?: string;
    defaultOptions?: DefaultOptions;
    cache?: ApolloCache<NormalizedCacheObject>;
    platformOptions?: PlatformOptions;
    typePolicies?: TypePolicies;
    errorLink?: ApolloLink;
    prforceGroups?: string;
    fragments?: FragmentRegistryAPI;
    placementId?: string;
}

export function OneGraphApolloClientProvider(props: Props): React.ReactNode {
    const {
        children,
        fetch,
        rootTrackingKey,
        defaultOptions,
        cache,
        platformOptions,
        typePolicies,
        errorLink,
        prforceGroups,
        fragments,
        placementId,
    } = props;

    const client = useMemo(() => {
        return createOneGraphApolloClient({
            fetch,
            trackingKey: rootTrackingKey,
            defaultOptions,
            cache,
            platformOptions,
            typePolicies,
            errorLink,
            prforceGroups,
            fragments,
            placementId,
        });
    }, [
        rootTrackingKey,
        defaultOptions,
        cache,
        platformOptions,
        fetch,
        typePolicies,
        errorLink,
        prforceGroups,
        fragments,
        placementId,
    ]);

    return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
